import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { AuthenticationService } from '@sb-tools/typescript/authentication/authentication.service';
import { isPlatformBrowser } from '@angular/common';
import { WindowRef } from '@sb-tools/typescript/services/window-ref.service';
import { LogOffOptions } from '@sb-tools/typescript/authentication/log-off-options.model';

@Injectable({ providedIn: 'root' })
export class CanActivateSettings {
    constructor(
        private authenticationService: AuthenticationService,
        private windowRef: WindowRef,
        @Inject(PLATFORM_ID) private platformId: string,
    ) {}

    canActivate(): boolean {
        if (this.authenticationService.isLoggedIn()) {
            return true;
        }

        const logOffOptions: LogOffOptions = {};

        if (isPlatformBrowser(this.platformId)) {
            logOffOptions.isNeedRedirect = true;
            logOffOptions.redirectUrl = this.windowRef.nativeWindow.location.href;
        }

        this.authenticationService.logOff(logOffOptions);

        return false;
    }
}
